// extracted by css-extract-rspack-plugin
export default {"resizableCell":"dlBQZcRFKkmRfnKP","tableData":"TkqaXor7JWs5oxQS"};